import { useMutation } from '@tanstack/react-query';
import { postUnifiedEpoSearchLazy } from '../../../api/v2/epo';

export const useUnifiedEpoList = () => {
  const unifiedEpoLazyLoadMutation = useMutation({
    mutationFn: (payload) => postUnifiedEpoSearchLazy(payload),
  });

  return { unifiedEpoLazyLoadMutation };
};
